{
  "version": 1,
  "asset_id": "4a2101f5-ea55-477e-9d75-c9b819a95873",
  "project_id": "a43a2cae-46aa-465b-955b-909a5ab882b4",
  "url": "/__l5e/assets-v1/4a2101f5-ea55-477e-9d75-c9b819a95873/smart-word-labs-logo.png",
  "r2_key": "a/v1/a43a2cae-46aa-465b-955b-909a5ab882b4/4a2101f5-ea55-477e-9d75-c9b819a95873/smart-word-labs-logo.png",
  "original_filename": "smart-word-labs-logo.png",
  "size": 30166,
  "content_type": "image/webp",
  "created_at": "2026-08-10T13:54:30Z"
}
